import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import { Typography, Link, StatusChip } from '@occc-app/design-system';
import { ProductGroupFragment } from '@occc/graphql';

interface IProductGroupSelectReadOnlyProps {
  groups: ProductGroupFragment[];
  ineligibleType?: boolean;
}

export const ProductGroupSelectReadOnly: React.FC<IProductGroupSelectReadOnlyProps> = ({
  groups,
  ineligibleType,
}) => {
  const navigate = useNavigate();
  const selectedOptionsLinks = groups.map((selectedOption) => {
    const onClick = () => {
      navigate(`/product-groups/${selectedOption.id}`);
    };
    const label = <Link onClick={onClick}>{selectedOption.name}</Link>;

    return <StatusChip key={selectedOption.id} variant='success' label={label} />;
  });

  return (
    <Box mb={2}>
      <Typography variant='subtitle1' paragraph>
        {ineligibleType ? 'Excluded Product Groups' : 'Included Product Groups'}
      </Typography>
      <Box>{selectedOptionsLinks}</Box>
    </Box>
  );
};
